// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F3k1","col":"styles_col__2nJyB"};